import $ from 'jquery';
import 'jquery-minicolors';
import { preventScrolling, enableScrolling } from './scrolling';

const Template =
  '<div class="small-colorpicker">' +
  '<div class="small-colorpicker-colors"></div>' +
  '</div>';
const Colors = [
  { name: '--aha-color-picker–red-1', default: 'ee9999' },
  { name: '--aha-color-picker-orange-1', default: 'fdd4a3' },
  { name: '--aha-color-picker-yellow-1', default: 'ffee99' },
  { name: '--aha-color-picker-green1-1', default: 'dfefc5' },
  { name: '--aha-color-picker-green2-1', default: 'c1e39d' },
  { name: '--aha-color-picker-blue1-1', default: 'bddcdd' },
  { name: '--aha-color-picker-blue2-1', default: '99c7ec' },
  { name: '--aha-color-picker-blue3-1', default: 'c5dfe9' },
  { name: '--aha-color-picker-purple1-1', default: 'c2b7c8' },
  { name: '--aha-color-picker-purple2-1', default: 'ddbec7' },
  { name: '--aha-color-picker-pink-1', default: 'f7c6c3' },
  { name: '--aha-color-picker-tan-1', default: 'f1e2cf' },
  { name: '--aha-color-picker-black-1', default: 'a5a5a5' },
  { name: '--aha-color-picker-white-1', default: 'ffffff' },
  { name: '--aha-color-picker–red-2', default: 'e24d4d' },
  { name: '--aha-color-picker-orange-2', default: 'fbb35f' },
  { name: '--aha-color-picker-yellow-2', default: 'ffe24d' },
  { name: '--aha-color-picker-green1-2', default: 'c8e29a' },
  { name: '--aha-color-picker-green2-2', default: '93cd54' },
  { name: '--aha-color-picker-blue1-2', default: '8cc1c3' },
  { name: '--aha-color-picker-blue2-2', default: '4d9ddd' },
  { name: '--aha-color-picker-blue3-2', default: '9ac8d9' },
  { name: '--aha-color-picker-purple1-2', default: '95829e' },
  { name: '--aha-color-picker-purple2-2', default: 'c38d9e' },
  { name: '--aha-color-picker-pink-2', default: 'f09c95' },
  { name: '--aha-color-picker-tan-2', default: 'e7cdab' },
  { name: '--aha-color-picker-black-2', default: '7f7f7f' },
  { name: '--aha-color-picker-white-2', default: 'f2f2f2' },
  { name: '--aha-color-picker–red-3', default: 'd50000' },
  { name: '--aha-color-picker-orange-3', default: 'f9931a' },
  { name: '--aha-color-picker-yellow-3', default: 'ffd500' },
  { name: '--aha-color-picker-green1-3', default: 'b0d66e' },
  { name: '--aha-color-picker-green2-3', default: '64b80a' },
  { name: '--aha-color-picker-blue1-3', default: '5ba7a9' },
  { name: '--aha-color-picker-blue2-3', default: '0173cf' },
  { name: '--aha-color-picker-blue3-3', default: '6fb0c8' },
  { name: '--aha-color-picker-purple1-3', default: '674c75' },
  { name: '--aha-color-picker-purple2-3', default: 'a95c74' },
  { name: '--aha-color-picker-pink-3', default: 'ea7168' },
  { name: '--aha-color-picker-tan-3', default: 'dcb787' },
  { name: '--aha-color-picker-black-3', default: '666666' },
  { name: '--aha-color-picker-white-3', default: 'e5e5e5' },
  { name: '--aha-color-picker–red-4', default: 'aa0000' },
  { name: '--aha-color-picker-orange-4', default: 'c77615' },
  { name: '--aha-color-picker-yellow-4', default: 'ccaa00' },
  { name: '--aha-color-picker-green1-4', default: '8dab58' },
  { name: '--aha-color-picker-green2-4', default: '509308' },
  { name: '--aha-color-picker-blue1-4', default: '498687' },
  { name: '--aha-color-picker-blue2-4', default: '015ca6' },
  { name: '--aha-color-picker-blue3-4', default: '598da0' },
  { name: '--aha-color-picker-purple1-4', default: '523d5e' },
  { name: '--aha-color-picker-purple2-4', default: '874a5d' },
  { name: '--aha-color-picker-pink-4', default: 'bb5a53' },
  { name: '--aha-color-picker-tan-4', default: 'b0926c' },
  { name: '--aha-color-picker-black-4', default: '4c4c4c' },
  { name: '--aha-color-picker-white-4', default: 'd9d9d9' },
  { name: '--aha-color-picker–red-5', default: '800000' },
  { name: '--aha-color-picker-orange-5', default: '955810' },
  { name: '--aha-color-picker-yellow-5', default: '998000' },
  { name: '--aha-color-picker-green1-5', default: '6a8042' },
  { name: '--aha-color-picker-green2-5', default: '3c6e06' },
  { name: '--aha-color-picker-blue1-5', default: '376465' },
  { name: '--aha-color-picker-blue2-5', default: '01457c' },
  { name: '--aha-color-picker-blue3-5', default: '436a78' },
  { name: '--aha-color-picker-purple1-5', default: '3e2e46' },
  { name: '--aha-color-picker-purple2-5', default: '653746' },
  { name: '--aha-color-picker-pink-5', default: '8c443e' },
  { name: '--aha-color-picker-tan-5', default: '846e51' },
  { name: '--aha-color-picker-black-5', default: '000000' },
  { name: '--aha-color-picker-white-5', default: 'cccccc' },
];

class ColorPicker {
  constructor(element, options) {
    this.options = options ?? {};

    this.element = $(element);
    if (this.element.is('.disabled')) {
      return;
    }
    this.element.on('click', event => {
      if (this.options.colorAttribute) {
        this.colors = $(element).attr(this.options.colorAttribute).split(',');
      }

      if (!this.picker) {
        this.picker = this.createColorPicker();
      }
      this.placePicker();

      this.picker.off('click.colorPickerColor');
      this.picker.on(
        'click.colorPickerColor',
        '.small-colorpicker-color',
        event => {
          let hex = $(event.target).data('color');
          const colorVar = $(event.target).data('color-variable');

          const style = window.getComputedStyle(document.querySelector('body'));
          let resolvedHex = style.getPropertyValue(colorVar);
          resolvedHex = resolvedHex ? resolvedHex.trim() : hex;
          this.input.minicolors('value', resolvedHex);
          this.setHexColor(`#${hex}`, colorVar, resolvedHex);
          this.closePicker();
          return false;
        }
      );
      this.picker.on(
        'click.colorPickerColor',
        '.small-colorpicker-no-fill-button',
        event => {
          this.setNoFill();
          this.closePicker();
          return false;
        }
      );

      $(window).on('click', this.clickClosePicker);
    });
  }

  clickClosePicker = event => {
    if ($(event.target)[0] == this.element[0]) {
      return;
    }
    if ($(event.target).is('.small-colorpicker-custom')) {
      return;
    }
    if ($(event.target).is('.minicolors')) {
      return;
    }
    if ($(event.target).parents('.minicolors').length > 0) {
      return;
    }
    if ($(event.target).parent()[0] == this.element[0]) {
      return;
    }
    if (!this.picker.is(':visible')) {
      return;
    }
    this.closePicker();
  };

  closePicker = () => {
    if (window.enableScrolling) {
      enableScrolling();
    }
    $(window).off('click', this.clickClosePicker);

    if (this.hexColor && this.color) {
      this.element.trigger({
        type: 'changeColor',
        color: {
          hex: this.hexColor,
          converted: this.color,
          property: this.colorVar,
          displayHex: this.displayHex,
        },
      });
      this.hexColor = null;
      this.color = null;
      this.colorVar = null;
      this.displayHex = null;
    }

    if (this.picker) {
      this.picker.hide();
    }
  };

  createColorPicker = () => {
    let picker = $(Template).appendTo('body');
    picker.data('colorPicker', this);

    if (this.options.displayRight) {
      picker.addClass('display-right');
    }
    for (let color of Colors) {
      picker
        .find('.small-colorpicker-colors')
        .append(
          `<div class='small-colorpicker-color' data-color='${color.default}' data-color-variable='${color.name}' style='background-color: var(${color.name}, #${color.default});'></div>`
        );
    }

    picker.append("<div class='small-colorpicker-footer'></div>");
    let initialColor = this.element.data('color') || '#FFFFFF';
    if (initialColor[0] !== '#') {
      initialColor = `#${initialColor}`;
    }

    picker
      .find(
        `.small-colorpicker-color[data-color='${initialColor
          .replace('#', '')
          .toLowerCase()}']`
      )
      .addClass('selected');

    let footer = picker.find('.small-colorpicker-footer');

    if (this.options.noFill) {
      footer.append(`<div class='small-colorpicker-footer-item first-item pull-left'>
        <button href='#' class='btn small-colorpicker-no-fill-button'>${this.options.noFill}</button>
      </div>`);
    }

    footer.append(`<div class='small-colorpicker-footer-item pull-right'>
      <div class='small-colorpicker-custom-label'>Custom:</div>
      <input class='small-colorpicker-custom' value='${initialColor}'></input>
    </div>`);

    footer.append("<div class='clearfix'></div>");
    this.input = picker.find('.small-colorpicker-custom');
    this.input.minicolors({
      theme: 'colorpicker',
      change: hex => this.setHexColor(hex),
    });
    this.input.css({
      backgroundColor: initialColor,
      color: this.fontFromColor(initialColor),
    });
    this.input.on('keydown', event => {
      if (event.which === 13) {
        this.closePicker();
      }
    });
    picker.find('.minicolors-panel > div').each((_, div) =>
      $(div).css({
        top: parseInt($(div).css('top')) + 3,
        left: parseInt($(div).css('left')) + 3,
      })
    );
    return picker
      .find('.small-colorpicker-colors')
      .append("<div class='clearfix'></div>")
      .end();
  };

  setNoFill = () => {
    console.log('setNoFill', );
    this.hexColor = 'transparent';
    this.color = 'transparent';
    this.colorVar = undefined;
    this.displayHex = 'transparent';
    this.setHexColor('transparent', undefined, 'transparent');
  };

  setHexColor = (hex, colorVar, displayHex) => {
    if (!/(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(hex) && hex !== 'transparent') {
      return;
    }
    if (!this.options.dontSetElementColor) {
      this.element.css({ backgroundColor: displayHex || hex });
    }
    this.input.css({
      backgroundColor: displayHex || hex,
      color: this.fontFromColor(hex),
    });
    hex = hex.replace('#', '');
    let rgb = this.hexToRGB(hex);
    this.hexColor = hex;
    this.color =
      (1 << 24) |
      (parseInt(rgb.r) << 16) |
      (parseInt(rgb.g) << 8) |
      parseInt(rgb.b);
    console.log('color', this.color);
    this.colorVar = colorVar;
    this.displayHex = displayHex;
    this.picker
      .find('.small-colorpicker-color.selected')
      .removeClass('selected');
    this.picker
      .find(`.small-colorpicker-color[data-color='${hex.toLowerCase()}']`)
      .addClass('selected');
  };

  placePicker = () => {
    this.picker.show();
    if (window.preventScrolling) {
      preventScrolling();
    }
    let elemRect = this.element[0].getBoundingClientRect();
    let css = {};
    if (elemRect.bottom - elemRect.height / 2 < window.innerHeight / 2) {
      css.top = this.element.offset().top + this.element.outerHeight();
      this.picker
        .addClass('small-colorpicker-top-arrow')
        .removeClass('small-colorpicker-bottom-arrow');
    } else {
      css.top = this.element.offset().top - this.picker.outerHeight();
      this.picker
        .addClass('small-colorpicker-bottom-arrow')
        .removeClass('small-colorpicker-top-arrow');
    }

    if (elemRect.right - elemRect.width / 2 < window.innerWidth / 2) {
      css.left = this.element.offset().left - 8;
      this.picker
        .addClass('small-colorpicker-left-arrow')
        .removeClass('small-colorpicker-right-arrow');
    } else {
      css.left =
        this.element.offset().left +
        this.element.width() -
        this.picker.outerWidth() +
        8;
      this.picker
        .addClass('small-colorpicker-right-arrow')
        .removeClass('small-colorpicker-left-arrow');
    }

    this.picker.css(css);
  };

  fontFromColor = hex => {
    let rgb = this.hexToRGB(hex.replace('#', ''));
    let a = 1 - (0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b) / 255;
    if (a < 0.5) return '#000000';
    else return '#FFFFFF';
  };

  hexToRGB = colorHex => {
    let bigint = parseInt(colorHex, 16);
    if (isNaN(bigint)) return { r: 0, g: 0, b: 0, a: 0 };
    return { r: (bigint >> 16) & 255, g: (bigint >> 8) & 255, b: bigint & 255 };
  };
}

(function () {
  $.fn.colorPicker = function (options, ...args) {
    return this.each(() => {
      let $el = $(this);
      if (!$el.data('colorPicker')) {
        $el.data('colorPicker', new ColorPicker($el, options));
      }
    });
  };
})();
